export enum AppLanguage {
	FR = 'fr',
	EN = 'en'
}
